// @flow

import React, { PureComponent } from 'react';
import Icon from 'Common/Icon';

// Helpers
import classNames from 'classnames';
import styles from 'components/PartnershipLogo.scss';
import PropTypes from 'prop-types';

/**
 * <PartnershipLogo /> component.
 * @return {object} -
 */
export default class PartnershipLogo extends PureComponent<*> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} extendStyle - extendStyle name.
   */
  static propTypes = {
    extendStyle: PropTypes.string
  };

  /**
   * Renders <PartnershipLogo /> component.
   *
   * @return {JSX} - renders a Button.
   */
  render(): Element<*> | null {
    return (
      <div className={classNames(styles.logo, this.props.extendStyle)}>
        <span>powered by </span>
        <Icon iconName={'heycar'} size={'medium'} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Common/PartnershipLogo/index.js